<template>
    <div>
        <el-card shadow="hover">
            <div>
                <template style="float: left;">
                    <el-button type="primary" size="small" icon="el-icon-document-add" @click="doAdd()">添加</el-button>
                    <el-button-group style="margin-left:20px;" v-show="selRows.length > 0">
                        <el-tooltip effect="dark" content="删除" placement="top">
                            <el-button size="small" icon="el-icon-delete" @click="doDelete()"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>
                <el-form style="float: right" inline :model="query" size="small">
                    <div @keydown.enter="doQuery()">
                        <el-form-item>
                            <el-input v-model="query.tag" clearable placeholder="栏目标识" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.name" clearable placeholder="栏目名称" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" @selection-change="doSelectionChange" style="width: 100%">
                <el-table-column type="selection" width="40" />
                <el-table-column show-overflow-tooltip label="栏目信息">
                    <template slot-scope="scope">
                        <el-tag size="mini" type="danger" style="margin-right: 10px;" effect="dark" v-if="!scope.row.show">不显示</el-tag>
                        <span>{{ scope.row.name }} [ 标识：{{ scope.row.tag }} ]</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="栏目配置">
                    <template slot-scope="scope">
                        <span>链接：{{ scope.row.linkurl || '未配置' }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="栏目类型" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.type | type }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="排序值" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.sort }}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" @click.stop="doEdit(scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog title="详情" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="formDialog" width="500px">
            <el-form ref="form" :model="field" :rules="rules" label-width="80px">
                <el-form-item label="栏目名称" prop="name">
                    <el-input v-model="field.name" placeholder="请填写栏目名称"></el-input>
                </el-form-item>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="栏目标识" prop="tag">
                            <el-input v-model="field.tag" placeholder="请填写栏目标识"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="排序值" prop="sort">
                            <el-input-number style="width: 100%;" v-model="field.sort" label="请填写排序值"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="栏目类型" prop="type">
                            <el-select v-model="field.type" placeholder="请选择栏目类型">
                                <el-option label="文章" value="Article"></el-option>
                                <el-option label="图片" value="Picture"></el-option>
                                <el-option label="视频" value="Video"></el-option>
                                <el-option label="单页" value="Single"></el-option>
                                <el-option label="链接" value="Link"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否显示" prop="show">
                            <el-switch v-model="field.show" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="链接地址" prop="linkurl">
                    <el-input v-model="field.linkurl" placeholder="请填写链接地址"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmit">
                    保存
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialog = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const defaultQuery = {
    page: 1,
    size: 10,
    time: 0,
    name: '',
    tag: ''
}
const defaultField = {
    id: '',
    name: '',
    tag: '',
    type: 'Article',
    show: true,
    linkurl: '',
    sort: 0
}
export default {
    name: 'CmsCatalog',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            selRows: [],
            field: {
                ...defaultField
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请填写栏目名称',
                        trigger: 'blur'
                    }
                ],
                tag: [
                    {
                        required: true,
                        message: '请填写栏目标识',
                        trigger: 'blur'
                    }
                ],
                type: [
                    {
                        required: true,
                        message: '请选择栏目类型',
                        trigger: 'blur'
                    }
                ],
                show: [
                    {
                        required: true,
                        message: '请选择是否显示',
                        trigger: 'blur'
                    }
                ],
                sort: [
                    {
                        required: true,
                        message: '请填写排序值',
                        trigger: 'blur'
                    }
                ]
            },
            formDialog: false,
            submitLoading: false
        }
    },
    filters: {
        type: value => {
            switch (value) {
                case 'Article':
                    return '文章'
                case 'Picture':
                    return '图片'
                case 'Video':
                    return '视频'
                case 'Single':
                    return '单页'
                case 'Link':
                    return '链接'
                default:
                    return '未定义'
            }
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['网站管理', '栏目管理'])
        this.init()
    },
    methods: {
        init() {
            this.doLoad()
        },
        doLoad() {
            this.tableLoading = true
            this.$http
                .get('/ops/cms/catalog/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                ...defaultQuery
            }
            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        doSelectionChange(rows) {
            this.selRows = rows
        },
        clearFields() {
            this.field = {
                ...defaultField
            }
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
                this.$refs['form'].clearValidate()
            }
        },
        doAdd() {
            this.clearFields()
            this.formDialog = true
        },
        doEdit(item) {
            this.clearFields()
            this.field = {
                ...item
            }
            this.formDialog = true
        },
        doSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    this.$http.post('/ops/cms/catalog/save', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialog = false
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doDelete(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要删除的内容')
                return
            }
            this.$confirm('是否删除[' + names.join() + ']?删除后将无法恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/cms/catalog/delete', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('删除成功')
                            this.doLoad()
                        }
                    })
            })
        }
    }
}
</script>
